import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=d6a617ce&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=d6a617ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a617ce",
  null
  
)

export default component.exports